import React from 'react';

var DripUnauthorized = function DripUnauthorized() {
  return /*#__PURE__*/React.createElement("img", {
    src: "//img11.360buyimg.com/imagetools/jfs/t1/198806/17/12724/39958/61653c04E8efc2c89/a9e2b3ba63037db2.png",
    width: "252",
    height: "147",
    alt: "403"
  });
};

export default DripUnauthorized;